<template>
  <app-content title="">
    {{ redirectingInfoText }}
  </app-content>
</template>

<script lang="ts">
import AppContent from "@/app/shared/components/app-content/app-content.vue";
import { Component } from "vue-property-decorator";
import { BaseAuthOnlineComponent } from "./shared/components/base-auth-component/base-auth-online-component";
import { CatchError } from "./shared/services/helper/catch-helper";
import { OopsError } from "./shared/services/errors/oops-error";
import { appLocalStorage } from "./shared/services/app-storage/app-storage";
import { DASHBOARD_HAS_HOME_STORAGE_KEY } from "./app-routes";

@Component({
  name: "app-home",
  components: {
    AppContent,
  },
})
export default class AppHome extends BaseAuthOnlineComponent {
  redirectingInfoText = "";

  @CatchError()
  async created() {
    this.redirectingInfoText = this.$t("redirecting").toString();

    const dashboardAsHome = appLocalStorage.getItem(DASHBOARD_HAS_HOME_STORAGE_KEY) !== false;
    if (dashboardAsHome && this.hasPerm(this.p.READ_DASHBOARD)) {
      this.$router.push({ name: "Dashboard" });
      return;
    }

    let onlyPlantId: string | null = null;
    if (!this.isAdmin && this.hasPerm(this.p.READ_AVAILABLE_PLANT)) {
      onlyPlantId = (await this.volateqApi.getOnlyAvailablePlantId()).id;
    }
    if (onlyPlantId) {
      this.$router.push({ name: "Plant", params: { id: onlyPlantId } });
      return;
    }

    if (this.hasPermPlantView) {
      this.$router.push({ name: "Plants" });
      return;
    }

    if (this.hasPerm(this.p.READ_ANALYSIS)) {
      this.$router.push({ name: "Analyses" });
      return;
    }

    this.redirectingInfoText = this.$t("cannot-redirect-no-permissions").toString();

    throw new OopsError("E0x0666", "Unsufficient permissions");
  }
}
</script>
